import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Collapse, Table } from 'antd';
//Components
import Wait4Me from '../../../components/Wait4Me';
import BreadCrumb from '../../../components/BreadCrumb';
import NoDataToDisplay from '../../../components/NoDataToDisplay';
import TicketDetailTopPannel from './components/TicketDetailTopPannel';
import ChampionOrChallengerBasicDetail from './components/ChampionOrChallengerBasicDetail';
import NewChallengerCta from './components/ChallengerCTA';
import { ROUTE_AMLS_SMART_SCREENING } from '../../constants/globalConstants';

import RejectConfirmationModal from '../../../components/ns/TicketsTable/RejectConfirmationModal';
import WatchAndWhitelistTable from '../../../components/ns/WatchAndWhitelistTable';

import style from './index.scss';
import { CaretRightFilled } from '@ant-design/icons';
import { get } from 'lodash';
import { getAttributeByResourceCode } from '../../../util/miscellaneousUtils';
import { GSKeyByProductSourceId, GSBasedOnProduct } from './utils/gsUtils';
import { getSelectedResources } from '../../../util/resourceManager';

const { Panel } = Collapse;

const getTicketDetailsResourceCode = () => {
  const { trmResources } = getSelectedResources();
  return trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET;
};

const ticketDetailsResourceCode = getTicketDetailsResourceCode();

export const TicketDetails = ({
  apiActions,
  settings,
  location,
  championChallengerDetails,
  match,
  currentChampion,
  approveAndReject,
  authentication,
  alertLevels
}) => {
  const {
    navigateTo,
    getNSGlobalSettingsPageInfo,
    getCurrentChampion,
    getChampionChallengerDetails,
    fetchAMLSAlertLevel
  } = apiActions;

  const championViewDetails = {
    watchlist: {
      data: { ...championChallengerDetails?.data?.champion?.watchlist },
      isLoading: championChallengerDetails?.isChampionLoading,
      error: null
    },
    whitelist: {
      data: { ...championChallengerDetails?.data?.champion?.whitelist },
      isLoading: championChallengerDetails?.isChampionLoading,
      error: null
    },
    matchingConfigs: championChallengerDetails?.data?.champion?.matchingConfigs
  };

  const challengerViewDetails = {
    watchlist: {
      data: { ...championChallengerDetails?.data?.challenger?.watchlist },
      isLoading:
        championChallengerDetails?.isChallengerLoading ||
        championChallengerDetails?.isChampionLoading,
      error: null
    },
    whitelist: {
      data: { ...championChallengerDetails?.data?.challenger?.whitelist },
      isLoading:
        championChallengerDetails?.isChallengerLoading ||
        championChallengerDetails?.isChampionLoading,
      error: null
    },
    matchingConfigs:
      championChallengerDetails?.data?.challenger?.matchingConfigs
  };

  const getFinalArrayByKey = (key) => {
    let finalArray = [];

    if (
      championChallengerDetails?.data?.champion?.[key] &&
      championChallengerDetails?.data?.challenger?.[key]
    ) {
      let sourceObject = {},
        ticketObject = {},
        matchedArray = [];
      championChallengerDetails?.data?.champion?.[key].forEach((item) => {
        sourceObject[item.id] = item;
      });
      championChallengerDetails?.data?.challenger?.[key].forEach((item) => {
        ticketObject[item.id] = item;
      });
      for (const item in sourceObject) {
        for (const i in ticketObject) {
          if (item === i) {
            matchedArray.push(sourceObject[item]);
            delete sourceObject[item];
            delete ticketObject[item];
          }
        }
      }
      finalArray.push(...matchedArray);
      if (Object.keys(ticketObject).length) {
        finalArray.push({ id: 'Added' });
        for (const i in ticketObject) {
          finalArray.push(ticketObject[i]);
        }
      }
      if (Object.keys(sourceObject).length) {
        finalArray.push({ id: 'Deleted' });
        for (const i in sourceObject) {
          finalArray.push(sourceObject[i]);
        }
      }
    }
    return finalArray;
  };

  let finalWatchListData = {};
  finalWatchListData = {
    isLoading: false,
    error: null,
    data: { ...getFinalArrayByKey('watchlist') }
  };

  let finalWhiteListData = {};
  finalWhiteListData = {
    isLoading: false,
    error: null,
    data: { ...getFinalArrayByKey('whitelist') }
  };

  const [isRejectConfirmationModalOpen, setIsRejectConfirmationModalOpen] =
    useState(false);
  const [rowSelected, setRowSelected] = useState(null);

  const GSKey = GSKeyByProductSourceId(location?.state?.sourceId); //Get the Global settings key based on the product source ID

  let moduleGS; //Current Module specific Global settings

  if (GSKey) {
    moduleGS = GSBasedOnProduct[GSKey];
  }

  useEffect(() => {
    getNSGlobalSettingsPageInfo({ pageId: moduleGS.pageId });
    getChampionChallengerDetails({
      id: location?.state?.challengerId,
      key: 'challenger'
    });

    // Fetch the alert level configuration to display the configured values and colors for alert levels on the ticket details page.
    if (!alertLevels?.length) {
      fetchAMLSAlertLevel();
    }
  }, []);

  useEffect(() => {
    const sourceId =
      get(championChallengerDetails, 'data.champion.sourceId', null) ||
      get(championChallengerDetails, 'data.challenger.sourceId', null);
    if (sourceId && !get(currentChampion, 'data', null)) {
      getCurrentChampion(sourceId);
    }
  }, [championChallengerDetails]);

  const getGSConfig = (q) => {
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  const renderExpandIcon = () => <CaretRightFilled />;

  const onRejectIconClickedHandler = (data) => {
    setRowSelected(data);
    setIsRejectConfirmationModalOpen(true);
  };

  const renderWatchAndWhitelistTable = (data, widgetId) => {
    return (
      <WatchAndWhitelistTable
        tableData={data}
        GS={getGSConfig({
          widgetGroupId: moduleGS.challengerDetailsWidgetGroupId,
          widgetId: widgetId
        })}
        hasRowSelection={false}
        hasPagination={false}
        component="TicketDetails"
      />
    );
  };

  const columns = [
    {
      title: 'Customer Type',
      dataIndex: 'customerTypeDisplayName',
      key: 'customerTypeDisplayName',
      render: (text, record) => {
        if (record?.isDefault && text == null) return 'Default';
        else if (text) return text;
        else return '--';
      }
    },
    {
      title: 'Matching Configuration Name',
      dataIndex: 'matchingConfigName',
      key: 'matchingConfigName'
    }
  ];

  return (
    <Row>
      <Col span={24}>
        <div className={style.wrapper}>
          {settings?.nsSetting?.isLoading ||
          championChallengerDetails?.isChampionLoading ||
          championChallengerDetails?.isChallengerLoading ||
          currentChampion?.isLoading ? (
            <div className={style.loadingWrapper}>
              <Wait4Me />
            </div>
          ) : championChallengerDetails?.error !== null ? (
            <div className={style.noDataToDisplayWrapper}>
              <NoDataToDisplay />
            </div>
          ) : (
            <React.Fragment>
              <div className={style.head}>
                <BreadCrumb
                  crumbs={[
                    {
                      label: 'Tickets',
                      linkTo: `${ROUTE_AMLS_SMART_SCREENING}/tickets`
                    },
                    { label: 'Ticket Details' }
                  ]}
                />
                <TicketDetailTopPannel
                  GS={getGSConfig({
                    widgetGroupId: moduleGS.ticketBasicDetailsWidgetGroupId,
                    widgetId: moduleGS.ticketBasicDetailsWidgetId
                  })}
                  navigateTo={navigateTo}
                  data={{ ticketId: match?.params?.id }}
                />
              </div>
              {championChallengerDetails?.data?.champion === undefined ? (
                <div className={style.ticketDetailBody}>
                  {' '}
                  {/* Days 0 */}
                  <ChampionOrChallengerBasicDetail
                    title={`New Champion: ${
                      location?.state?.itemName ? location?.state?.itemName : ''
                    }`}
                    GS={getGSConfig({
                      widgetGroupId: moduleGS.challengerDetailsWidgetGroupId,
                      widgetId: moduleGS.challengerExecutionDetailsWidgetId
                    })}
                    data={championChallengerDetails?.data?.challenger}>
                    <NewChallengerCta
                      GS={getGSConfig({
                        widgetGroupId: moduleGS.challengerDetailsWidgetGroupId,
                        widgetId: moduleGS.challengerRunIndtanceWidgetId
                      })}
                      onRejectIconClickedHandler={onRejectIconClickedHandler}
                      location={location}
                      match={match}
                      apiActions={apiActions}
                      data={championChallengerDetails?.data?.challenger}
                    />
                  </ChampionOrChallengerBasicDetail>
                  <Collapse
                    defaultActiveKey={['0']}
                    ghost
                    accordion={false}
                    id="expandCollapse"
                    expandIcon={renderExpandIcon}>
                    <Panel header={`View Details`} key="1">
                      {getAttributeByResourceCode(
                        authentication,
                        ticketDetailsResourceCode
                      ) !== '17' && (
                        <>
                          <span className={style.headingLabel}>Watchlists</span>
                          {challengerViewDetails?.watchlist?.data &&
                            renderWatchAndWhitelistTable(
                              challengerViewDetails?.watchlist,
                              moduleGS.challengerWatchListId
                            )}
                        </>
                      )}

                      <span className={style.headingLabel}>Whitelists</span>
                      {challengerViewDetails?.whitelist?.data &&
                        renderWatchAndWhitelistTable(
                          challengerViewDetails?.whitelist,
                          moduleGS.challengerWhiteListId
                        )}

                      <span className={style.headingLabel}>
                        Matching Configurations
                      </span>
                      <div className={style.matchingConfigTable}>
                        <Table
                          columns={columns}
                          dataSource={challengerViewDetails.matchingConfigs}
                          pagination={false}
                        />
                      </div>
                    </Panel>
                  </Collapse>
                </div>
              ) : (
                <React.Fragment>
                  {' '}
                  {/* Days N or N + 1 */}
                  <div className={style.ticketDetailBody}>
                    <ChampionOrChallengerBasicDetail
                      title={'Current Champion (In Production)'}
                      GS={getGSConfig({
                        widgetGroupId: moduleGS.challengerDetailsWidgetGroupId,
                        widgetId: moduleGS.challengerExecutionDetailsWidgetId
                      })}
                      data={championChallengerDetails?.data?.champion}
                    />
                    <Collapse
                      ghost
                      accordion={false}
                      expandIcon={renderExpandIcon}>
                      <Panel header={`View Details`} key="1">
                        {/* {getAttributeByResourceCode(
                          authentication,
                          ticketDetailsResourceCode
                        ) !== '17' && (
                          <>
                            <span className={style.headingLabel}>
                              Watchlists
                            </span>
                            {championViewDetails?.watchlist?.data &&
                              renderWatchAndWhitelistTable(
                                championViewDetails?.watchlist,
                                moduleGS.challengerWatchListId
                              )}
                          </>
                        )} */}

                        {/* <span className={style.headingLabel}>Whitelists</span>
                        {championViewDetails?.whitelist?.data &&
                          renderWatchAndWhitelistTable(
                            championViewDetails?.whitelist,
                            moduleGS.challengerWhiteListId
                          )} */}

                        <span className={style.headingLabel}>
                          Matching Configurations
                        </span>
                        <div className={style.matchingConfigTable}>
                          <Table
                            columns={columns}
                            dataSource={championViewDetails.matchingConfigs}
                            pagination={false}
                          />
                        </div>
                      </Panel>
                    </Collapse>
                  </div>
                  <div className={style.ticketDetailBody}>
                    <ChampionOrChallengerBasicDetail
                      title={`New Challenger ID: 
                      ${
                        location?.state?.challengerId
                          ? location?.state?.challengerId
                          : ''
                      }`}
                      GS={getGSConfig({
                        widgetGroupId: moduleGS.challengerDetailsWidgetGroupId,
                        widgetId: moduleGS.challengerExecutionDetailsWidgetId
                      })}
                      data={championChallengerDetails?.data?.challenger}>
                      <NewChallengerCta
                        GS={getGSConfig({
                          widgetGroupId:
                            moduleGS.challengerDetailsWidgetGroupId,
                          widgetId: moduleGS.challengerRunInstanceWidgetId
                        })}
                        onRejectIconClickedHandler={onRejectIconClickedHandler}
                        location={location}
                        match={match}
                        apiActions={apiActions}
                        data={championChallengerDetails?.data?.challenger}
                      />
                    </ChampionOrChallengerBasicDetail>
                    <Collapse
                      defaultActiveKey={['1']}
                      ghost
                      accordion={false}
                      expandIcon={renderExpandIcon}>
                      <Panel header={`View Details`} key="1">
                        {/* {getAttributeByResourceCode(
                          authentication,
                          ticketDetailsResourceCode
                        ) !== '17' && (
                            <>
                              <span className={style.headingLabel}>
                                Watchlists
                              </span>
                              {finalWatchListData &&
                                renderWatchAndWhitelistTable(
                                  finalWatchListData,
                                  moduleGS.challengerWatchListId
                                )}
                            </>
                          )} */}

                        {/* <span className={style.headingLabel}>Whitelists</span>
                        {finalWhiteListData &&
                          renderWatchAndWhitelistTable(
                            finalWhiteListData,
                            moduleGS.challengerWhiteListId
                          )} */}

                        <span className={style.headingLabel}>
                          Matching Configurations
                        </span>
                        <div className={style.matchingConfigTable}>
                          <Table
                            columns={columns}
                            dataSource={challengerViewDetails.matchingConfigs}
                            pagination={false}
                          />
                        </div>
                      </Panel>
                    </Collapse>
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          )}

          {isRejectConfirmationModalOpen && (
            <RejectConfirmationModal
              data={rowSelected}
              open={isRejectConfirmationModalOpen}
              isModalOpen={setIsRejectConfirmationModalOpen}
              onRejectConfirmed={
                apiActions?.putAMLSCommonApproveAndRejectTicket
              }
              approveAndRejectData={approveAndReject}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

TicketDetails.propTypes = {
  apiActions: PropTypes.shape({
    navigateTo: PropTypes.func.isRequired,
    getNSGlobalSettingsPageInfo: PropTypes.func.isRequired,
    getCurrentChampion: PropTypes.func.isRequired,
    getChampionChallengerDetails: PropTypes.func.isRequired,
    putAMLSCommonApproveAndRejectTicket: PropTypes.func.isRequired
  }).isRequired,
  settings: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  championChallengerDetails: PropTypes.object,
  approveAndReject: PropTypes.object,
  currentChampion: PropTypes.object,
  authentication: PropTypes.object,
  alertLevels: PropTypes.array
};

export default TicketDetails;
